import cx from 'classnames';
import { defineMessages, useIntl } from 'react-intl';
import { Form, Grid, Input } from 'semantic-ui-react';

const messages = defineMessages({
  labelRequiredField: {
    id: 'label-required-field',
    defaultMessage: 'Required field',
  },
});

export const TextField = ({
  label,
  field,
  type = 'text',
  hasError = false,
  placeholder,
  required = false,
}: {
  label: string;
  placeholder?: string;
  field: string;
  type?: string;
  hasError?: boolean;
  required?: boolean;
}) => {
  const intl = useIntl();
  return (
    <Form.Field
      inline
      className={cx('help', required && 'required')}
      error={hasError}
    >
      <Grid>
        <Grid.Row stretched>
          <Grid.Column computer={4} mobile={12}>
            <div className="wrapper">
              <label htmlFor={field}>
                {label}&nbsp;
                {required && (
                  <span className="label-required">
                    ({intl.formatMessage(messages.labelRequiredField)})
                  </span>
                )}
              </label>
            </div>
          </Grid.Column>
          <Grid.Column computer={8} mobile={12}>
            {/* eslint-disable jsx-a11y/no-autofocus */}
            <Input
              id={field}
              name={field}
              placeholder={placeholder || label}
              autoFocus
              required={required}
              type={type}
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Form.Field>
  );
};
